import React from "react";
import {
    UiCol,
    UiRowContainer,
    UiSingleContainer,
    UiSingleRow,
} from "../../../../_uiComponents/grid-container/GridContainer";
import {
    UiTopShopBgSlider,
    UiInnerTopBgSlider,
    UiTopBgSliderInnerContent,
} from "../../../../_uiComponents/common/UiTopBgSliderElements";

export default function ShopInnerBanner(props) {
    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopShopBgSlider>
                    <UiSingleRow className={props.className}>
                        <UiCol lg="12">
                            <UiTopBgSliderInnerContent>
                                <h2>{props.title}</h2>
                                <p className="sb-top-bg-slider__slider-content-description">
                                    {props.description}
                                </p>
                            </UiTopBgSliderInnerContent>
                        </UiCol>
                    </UiSingleRow>
                </UiTopShopBgSlider>
            </UiInnerTopBgSlider>
        </>
    );
}
